import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { sendContactEmail } from "../utils/sendContactEmail";
import { useContentInfo, DEFAULT_CONTENT_INFO } from "../contexts/ContentContext";
import toast from "../utils/toast";

const Contact = () => {
    const { contentInfo } = useContentInfo();
    const logoURL = contentInfo?.footerLogoURL || DEFAULT_CONTENT_INFO.footerLogoURL;

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    });
    const [sending, setSending] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSending(true);
        try {
            await sendContactEmail(formData, logoURL);
            toast.success("Your message was sent successfully! We'll get back to you soon.");
            setFormData({ name: "", email: "", subject: "", message: "" });
        } catch (err) {
            console.error("Contact email failed:", err);
            toast.error("Something went wrong. Please try again or email us directly.");
        } finally {
            setSending(false);
        }
    };

    useEffect(() => {
        document.title = "Contact | dawaacare";
    }, [])

    return (
        <div>
            <Header />
            <div className="contact-page-wrapper">
                <div className="contact-bg-panel" />
                <div className="contact-form-panel" data-aos="fade-left" data-aos-duration="700">
                    <div className="contact-form-card">
                        <h1 className="contact-form-title">Contact Form</h1>

                        <form onSubmit={handleSubmit}>
                            <div className="contact-input-group">
                                <label className="contact-label" htmlFor="name">Name</label>
                                <input
                                    className="contact-input"
                                    type="text"
                                    id="name"
                                    name="name"
                                    placeholder="Enter your name here"
                                    required
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="contact-input-group">
                                <label className="contact-label" htmlFor="email">Email</label>
                                <input
                                    className="contact-input"
                                    type="email"
                                    id="email"
                                    name="email"
                                    placeholder="Enter your email here"
                                    required
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="contact-input-group">
                                <label className="contact-label" htmlFor="subject">Subject</label>
                                <input
                                    className="contact-input"
                                    type="text"
                                    id="subject"
                                    name="subject"
                                    placeholder="Enter your subject here"
                                    required
                                    value={formData.subject}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="contact-input-group">
                                <label className="contact-label" htmlFor="message">Message</label>
                                <textarea
                                    className="contact-textarea"
                                    id="message"
                                    name="message"
                                    rows="7"
                                    placeholder="Enter your message here"
                                    required
                                    value={formData.message}
                                    onChange={handleChange}
                                />
                            </div>

                            <button
                                type="submit"
                                className="contact-submit-btn"
                                disabled={sending}
                            >
                                {sending ? "Sending..." : "Submit"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            {/* <!-- map --> */}
            <div class="map-tab" data-aos="fade-up">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3361.3980090005!2d74.0796347!3d32.5955751!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391f05007c46918d%3A0xc00662da500cdfe9!2sDawaa%20Pharmacy!5e0!3m2!1sen!2s!4v1743139848524!5m2!1sen!2s"
                    style={{ border: "0", allow: "fullscreen", loading: "lazy", referrerpolicy: "no-referrer-when-downgrade", width: "100%", height: "450px", borderRadius: "20px", marginBottom: "100px" }}
                    title="Dawaa Pharmacy Location"
                    className="google-map"
                ></iframe>
            </div>
            <Footer />
        </div>
    );
};

export default Contact;
